import Header from './Header';

/**
 * Minimal page header — no image, clean white/stone background with CSS accent.
 * Used on all inner pages.
 */
const PageHeader = ({ title, subtitle, setCurrentSection, currentSection, children }) => (
  <div className="relative bg-white pt-24 pb-0 overflow-hidden">
    {/* Jersey-inspired gradient top accent */}
    <div className="absolute top-0 left-0 right-0 h-1 gradient-brand" />

    {/* Faint dot grid */}
    <div className="absolute inset-0 bg-dot-grid opacity-40 pointer-events-none" />

    {/* Decorative circles — top right */}
    <div className="absolute right-[-80px] top-[-80px] w-[400px] h-[400px] rounded-full border border-stone-100 pointer-events-none" />
    <div className="absolute right-[20px] top-[10px] w-[200px] h-[200px] rounded-full border border-stone-100 pointer-events-none" />

    <Header setCurrentSection={setCurrentSection} currentSection={currentSection} />

    <div className="relative z-10 max-w-6xl mx-auto px-5 py-12">
      <h1 className="display-lg mb-3">
        <span className="gradient-brand-text">{title}</span>
      </h1>
      {subtitle && (
        <p className="text-base text-stone-500 max-w-xl leading-relaxed">{subtitle}</p>
      )}
      {children && <div className="mt-8">{children}</div>}
    </div>

    {/* Bottom divider */}
    <div className="divider" />
  </div>
);

export default PageHeader;
